import React from "react";

export default function AppleIcon({ className = "w-5 h-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
      <path d="M16.365 1.43c0 1.14-.464 2.16-1.16 2.94-.79.9-2.03 1.6-3.15 1.5-.14-1.1.42-2.24 1.15-3 .82-.88 2.24-1.55 3.16-1.44zM20.5 17.35c-.5 1.15-1.1 2.28-2.02 3.32-.9 1.03-1.68 1.75-2.86 1.77-1.15.02-1.52-.72-2.83-.72-1.32 0-1.73.7-2.82.74-1.14.04-2.01-1.12-2.92-2.14-1.85-2.1-3.28-5.95-1.37-8.55.95-1.3 2.63-2.13 4.47-2.16 1.11-.02 2.16.75 2.83.75.68 0 1.94-.93 3.28-.79.56.02 2.13.23 3.13 1.73-.08.05-1.87 1.1-1.85 3.27.02 2.6 2.28 3.47 2.3 3.48-.02.06-.35 1.21-1.16 2.4z" />
    </svg>
  );
}